<template>
  <div
    v-if="!$store.state.desktop"
    id="footerBar"
    class="footerBar"
    :class="{
      'is-login': login,
      shadow: $route.name == 'Download',
      fixed: fixed,
    }"
  >
    <ul class="link">
      <router-link v-if="!teacher" tag="li" title="关于我们" :to="{ name: 'About' }">
        <span>关于我们</span>
      </router-link>
      <router-link v-if="!teacher" tag="li" title="联系我们" :to="{ name: 'ContactUs' }">
        <span>联系我们</span>
      </router-link>
      <a href="/teacher" v-if="!teacher">
        <span>讲师登录</span>
      </a>
      <!-- <a href="/assist" v-if="!teacher">
          <span>助教登录</span>
        </a> -->
    </ul>
    <p class="copyright">
      <span>{{ $store.state.webConfig.copyright }}</span>
      <a :href="$store.state.webConfig.record_no_link" target="_blank">
        {{ $store.state.webConfig.record_no }}
      </a>
      <a
        :href="$store.state.webConfig.public_security_record_no_link"
        target="_blank"
        style="margin-left: 18px"
      >
        <img src="@/assets/images/gongan.png" style="vertical-align: middle; margin-right: 5px" />
        <span>{{ $store.state.webConfig.public_security_record_no }}</span>
      </a>
    </p>
    <p class="copyright custom">
      {{ $store.state.webConfig.contact }}
    </p>
    <p
      class="copybottom"
      v-if="$store.state.commonSetting.saas_enable == 1 && $store.state.webConfig.show_brand == 1"
    >
      <span>
        由
        <a href="https://www.baijiayun.com" target="_blank">
          <img class="sm-logo" :src="smlogo" />
          百家云
        </a>
        |
        <a href="https://www.baijiayunxiao.com/index" target="_blank">
          <img class="sm-logo" :src="yxlogo" />
          百家云校
        </a>
        提供技术支持
      </span>
      <br />
      <span>SaaS网校，就用百家云校！</span>
    </p>
  </div>
</template>

<script>
import smlogo from '../assets/images/sm-logo.png';
import yxlogo from '../assets/images/yx-logo.png';
export default {
  name: 'Footer',
  props: {
    login: {
      default: false,
    },
    teacher: {
      default: false,
    },
    fixed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      smlogo,
      yxlogo,
    };
  },
};
</script>
<style lang="scss" scoped>
.footerBar {
  padding: 32px 0 31px 0;
  background: #666666;
  box-sizing: border-box;
  z-index: 999;
  position: relative;
  &.shadow {
    box-shadow: 0px 0px 40px 0px rgba(0, 0, 0, 0.05);
  }
  &.fixed {
    position: fixed;
    bottom: 0;
    width: 100%;
  }
}

.footerBar .link {
  text-align: center;
}

.footerBar .link li,
.footerBar .link a {
  margin-right: 54px;
  cursor: pointer;
  display: inline-block;
  font-size: 14px;
  color: white;
  line-height: 20px;
  &:last-child {
    margin-right: 0;
  }
}

.footerBar .link li.phone {
  border: none;
}

.footerBar .link li span,
.footerBar .link li a {
  display: block;
}

.footerBar .copyright {
  margin: 13px auto 0 auto;
  text-align: center;
  font-size: 15px;
  color: rgba($color: white, $alpha: 0.5);
  line-height: 20px;
  a {
    color: rgba($color: white, $alpha: 0.5);
    vertical-align: middle;
  }
  span {
    margin-right: 18px;
    vertical-align: middle;
  }
}

.custom {
  margin-top: 12px !important;
}
.copybottom {
  display: block;
  margin: 27px auto 0 auto;
  text-align: center;
  font-size: 14px;
  color: white;
  line-height: 16px;
  opacity: 0.5;
  a {
    color: white;
  }
  span {
    display: inline-block;
    color: white;
    margin-bottom: 5px;
  }
  .sm-logo {
    position: relative;
    top: 1px;
    height: 12px;
    width: 20px;
    margin: 0 5px;
    margin-top: 5px;
  }
}
</style>
